import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToKeyValue',
  standalone: false
})
export class EnumToKeyValuePipe implements PipeTransform {
  // NOTE: for enums with a string value, you can use the angular keyvalue pipe
  // for enums with number values, this pipe is necessary when iterating over it
  transform(data: object) {
    const kv = [];
    const keys = Object.keys(data);

    keys.slice(keys.length / 2).forEach(x => {
      kv.push({ key: x, value: data[x] });
    });

    return kv;
  }
}
